import { render, staticRenderFns } from "./RawMaterialConsumptionByBranch.vue?vue&type=template&id=5148df30&scoped=true"
import script from "./RawMaterialConsumptionByBranch.vue?vue&type=script&lang=js"
export * from "./RawMaterialConsumptionByBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5148df30",
  null
  
)

export default component.exports